import {
  AfterViewInit,
  Component,
  DestroyRef,
  ElementRef,
  HostListener,
  inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AppFeatureService } from '@nk/access-block';
import { LayoutConfig, LayoutService } from '@nk/core/services/layout.service';
import { isMobileScreenSize, isSmallMobileScreenSize } from '@nk/utils-lib';
import { Observable } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'nk-layout',
  templateUrl: './app-layout.component.html',
  standalone: false,
})
export class AppLayoutComponent implements OnInit, AfterViewInit {
  public layout$: Observable<LayoutConfig>;
  public isMobile = false; // also true if isSmallMobile
  public isSmallMobile = false;
  @ViewChild('header')
  public elementView: ElementRef;
  public headerHeight: number;
  @HostListener('window:resize', ['$event'])
  public onResize(): void {
    this.isMobile = isMobileScreenSize();
    this.isSmallMobile = isSmallMobileScreenSize();
    this.getHeaderHeight();
  }
  private _destroy = inject(DestroyRef);

  constructor(
    private _layoutService: LayoutService,
    private _appFeatureService: AppFeatureService,
  ) {}

  public ngOnInit(): void {
    this.isMobile = isMobileScreenSize();
    this.isSmallMobile = isSmallMobileScreenSize();
    this.layout$ = this._layoutService.getLayoutConfig().pipe(debounceTime(0));
    this._appFeatureService
      .appSubscriptionState()
      .pipe(takeUntilDestroyed(this._destroy))
      .subscribe(() => {
        this.getHeaderHeight();
      });

    // Disabled until we want to activate again. It slows the app down to check this on every page refresh.
    // // Fetch app surveys and display modal on condition
    // this._appService.identityDataCache
    //   .get()
    //   .pipe(
    //     mergeMap((identity) => {
    //       // Prevent showing survey if app_membership.opt_out_survey_timestamp is set,
    //       if (identity.app_membership.opt_out_survey_timestamp) {
    //         return of([]);
    //       }
    //       return this._appContentService.appSurveyCache.fetch(
    //         identity.app_membership.uuid,
    //         identity.app_user.language_code,
    //       );
    //     }),
    //   )
    //   .subscribe((appSurveys: AppSurveyEntity[]) => {
    //     if (appSurveys.length > 0) {
    //       this._modalService.show(SurveyFeedbackComponent, {
    //         initialState: {
    //           appSurveys: appSurveys,
    //         },
    //         ignoreBackdropClick: true,
    //       });
    //     }
    //   });
  }

  public getHeaderHeight(): void {
    setTimeout(() => {
      const htmlElement = this.elementView.nativeElement as HTMLElement;
      this.headerHeight = htmlElement.offsetHeight;
    }, 100);
  }

  public ngAfterViewInit(): void {
    this.getHeaderHeight();
  }
}
